import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Users, Building, Server, Globe } from "lucide-react";
import { PACKAGES, fadeInUp, staggerContainer } from "../data/constants";
import { PackageCard } from "../cards/PackageCard";
import { EnterpriseCard } from "../cards/EnterpriseCard";

export const PackagesSection = () => {
  const [selectedType, setSelectedType] = useState("hogar");

  const types = [
    { id: "hogar", label: "Hogar", icon: Users },
    { id: "negocios", label: "Negocios", icon: Building },
    { id: "empresarial", label: "Empresarial", icon: Server },
    { id: "dedicado", label: "Dedicado", icon: Globe },
  ];

  return (
    <section id="paquetes" className="py-24 bg-gray-50" data-testid="packages-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={staggerContainer}
          className="text-center mb-16"
        >
          <motion.span
            variants={fadeInUp}
            className="text-orange-500 font-semibold uppercase tracking-wider"
          >
            Nuestros Planes
          </motion.span>
          <motion.h2
            variants={fadeInUp}
            className="text-4xl md:text-5xl font-bold text-gray-900 mt-4"
          >
            Soluciones de Internet
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-xl text-gray-600 mt-4 max-w-2xl mx-auto">
            Elige el plan perfecto para tus necesidades. Todos nuestros precios incluyen IVA.
          </motion.p>
        </motion.div>

        {/* Type Selector */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {types.map((type) => {
            const Icon = type.icon;
            return (
              <button
                key={type.id}
                onClick={() => setSelectedType(type.id)}
                className={`flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-all ${
                  selectedType === type.id
                    ? "bg-orange-500 text-white shadow-lg shadow-orange-500/30"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
                data-testid={`package-type-${type.id}`}
              >
                <Icon className="w-5 h-5" />
                {type.label}
              </button>
            );
          })}
        </div>

        {/* Packages Grid */}
        <AnimatePresence mode="wait">
          <motion.div
            key={selectedType}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {selectedType === "hogar" &&
              PACKAGES.hogar.map((pkg, index) => (
                <PackageCard key={index} pkg={pkg} type="hogar" />
              ))}
            {selectedType === "negocios" &&
              PACKAGES.negocios.map((pkg, index) => (
                <PackageCard key={index} pkg={pkg} type="negocios" />
              ))}
            {selectedType === "empresarial" &&
              PACKAGES.empresarial.map((pkg, index) => (
                <EnterpriseCard key={index} pkg={pkg} type="empresarial" />
              ))}
            {selectedType === "dedicado" &&
              PACKAGES.dedicado.map((pkg, index) => (
                <EnterpriseCard key={index} pkg={pkg} type="dedicado" />
              ))}
          </motion.div>
        </AnimatePresence>

        <div className="text-center mt-12">
          <p className="text-gray-500">
            * Consulta la zona de cobertura. Configuración de servicio incluida.
          </p>
        </div>
      </div>
    </section>
  );
};
